import { render, staticRenderFns } from "./CreateTopic.vue?vue&type=template&id=5dae555b"
import script from "./CreateTopic.vue?vue&type=script&lang=js"
export * from "./CreateTopic.vue?vue&type=script&lang=js"
import style0 from "./CreateTopic.vue?vue&type=style&index=0&id=5dae555b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports